import { Box, Button, Grid, Typography, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactComponent as Clock } from 'assets/icons/clock.svg';
import CountdownTimer from 'component/CountDownTimer/CountdownTimer';
import { Ended, Stage1, Stage2, Stage2Final } from 'component/Common/StageTags';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { useTheme } from '@emotion/react';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import { postApiCall, stageTwoCounter } from 'api/apiService';
import {
  counterCont,
  counterContMarket,
  counterContMarketUpper,
} from 'component/LiveOfferStatus/CounterTimer.style';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';
import { poppins400 } from 'theme/common.style';
import PropertySettingAction from './PropertySettingAction';
import {
  counterSubProp,
  counterSubPropMarket,
  stageCont,
  stageContMarket,
  stageContMarketSt2,
  stageContMarketStage,
  stagePause,
} from './PropertyTimer.style';
import Timerstatus from 'component/LiveOfferStatus/Timerstatus';
import {
  POST_BUYER_BANNER_CLOSE,
  POST_BUYER_PRIVATEOFFER_VIEW,
  POST_VENDOR_BANNER_CLOSE,
  POST_VENDOR_BANNER_PRIVATE_OFFER,
  WINNER_VIEWED_BY_BUYER,
} from 'constant/app.config';
import PrivateOfferConfirmationPopup from 'component/VendorStatusContainer/PrivateOfferConfirmationPopup';

const ViewIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9949 5.8692C12.8604 5.87121 12.7311 5.91924 12.6304 6.00459C12.5298 6.08994 12.4644 6.20696 12.4462 6.33444C11.8969 6.54851 11.5035 7.0651 11.5035 7.66291C11.5035 8.08145 11.7148 8.44658 11.9613 8.68239C12.2078 8.9182 12.4799 9.06636 12.7143 9.20089C12.9487 9.33542 13.1455 9.45631 13.2505 9.55683C13.3556 9.65734 13.3787 9.6958 13.3787 9.81538C13.3787 10.0199 13.2175 10.1741 13.0037 10.1741C12.7899 10.1741 12.6286 10.0199 12.6286 9.81538C12.6297 9.74407 12.6159 9.67327 12.5881 9.6071C12.5603 9.54093 12.519 9.48071 12.4667 9.42992C12.4144 9.37914 12.352 9.33882 12.2832 9.31129C12.2144 9.28377 12.1406 9.2696 12.0661 9.2696C11.9915 9.2696 11.9177 9.28377 11.8489 9.31129C11.7801 9.33882 11.7178 9.37914 11.6654 9.42992C11.6131 9.48071 11.5718 9.54093 11.544 9.6071C11.5162 9.67327 11.5024 9.74407 11.5035 9.81538C11.5035 10.4134 11.8973 10.9299 12.447 11.1438C12.466 11.2722 12.5328 11.3898 12.6351 11.4748C12.7375 11.5598 12.8685 11.6066 13.004 11.6066C13.1396 11.6066 13.2706 11.5598 13.373 11.4748C13.4753 11.3898 13.5421 11.2722 13.5611 11.1438C14.1105 10.9298 14.5039 10.4132 14.5039 9.81538C14.5039 9.39684 14.2926 9.03171 14.0461 8.7959C13.7995 8.56009 13.5274 8.41193 13.293 8.2774C13.0586 8.14287 12.8619 8.02198 12.7568 7.92146C12.6517 7.82095 12.6286 7.7825 12.6286 7.66291C12.6286 7.45841 12.7899 7.30417 13.0037 7.30417C13.2175 7.30417 13.3787 7.45841 13.3787 7.66291C13.3777 7.73422 13.3914 7.80502 13.4192 7.87119C13.447 7.93736 13.4883 7.99759 13.5407 8.04837C13.593 8.09915 13.6554 8.13947 13.7242 8.167C13.7929 8.19452 13.8667 8.20869 13.9413 8.20869C14.0159 8.20869 14.0897 8.19452 14.1585 8.167C14.2272 8.13947 14.2896 8.09915 14.342 8.04837C14.3943 7.99759 14.4356 7.93736 14.4634 7.87119C14.4912 7.80502 14.5049 7.73422 14.5039 7.66291C14.5039 7.06487 14.1101 6.54836 13.5604 6.33444C13.5418 6.20422 13.474 6.08501 13.3698 5.9993C13.2657 5.91359 13.1323 5.86731 12.9949 5.8692Z"
        fill="#2184FD"
      />
      <path
        d="M13.0018 3C9.69429 3 7.00098 5.57621 7.00098 8.7399C7.00098 9.91982 7.38092 11.0714 8.0895 12.0373C8.13197 12.0951 8.18594 12.1445 8.24834 12.1824C8.31073 12.2203 8.38032 12.2461 8.45314 12.2583C8.52596 12.2705 8.60058 12.2689 8.67273 12.2535C8.74489 12.2381 8.81317 12.2093 8.87368 12.1687C8.93419 12.128 8.98574 12.0764 9.02539 12.0167C9.06504 11.957 9.09201 11.8905 9.10477 11.8208C9.11752 11.7512 9.1158 11.6798 9.09972 11.6108C9.08363 11.5418 9.05349 11.4764 9.01101 11.4186C8.43522 10.6337 8.12613 9.69869 8.12613 8.7399C8.12613 6.15785 10.3024 4.07623 13.0018 4.07623C15.7012 4.07623 17.8774 6.15785 17.8774 8.7399C17.8774 11.3219 15.7012 13.4036 13.0018 13.4036C11.9992 13.4036 11.0212 13.1081 10.2006 12.5572C10.1403 12.5142 10.0716 12.4833 9.99853 12.4662C9.92549 12.4492 9.84961 12.4462 9.77538 12.4577C9.70114 12.4691 9.63006 12.4947 9.56633 12.5329C9.50259 12.571 9.44751 12.621 9.40432 12.6799C9.36113 12.7388 9.33072 12.8053 9.31488 12.8756C9.29904 12.9459 9.29809 13.0186 9.31209 13.0892C9.3261 13.1599 9.35477 13.2272 9.39641 13.2871C9.43805 13.3469 9.49182 13.3982 9.55454 13.4379C10.5644 14.1159 11.768 14.4798 13.0018 14.4798C16.3093 14.4798 19.0026 11.9036 19.0026 8.7399C19.0026 5.57621 16.3093 3 13.0018 3Z"
        fill="#2184FD"
      />
      <path
        d="M1.56258 12.6856C1.25189 12.6856 1.00003 12.9266 1 13.2237V21.1161C1.00003 21.4133 1.25189 21.6542 1.56258 21.6542H4.18793C4.49862 21.6542 4.75047 21.4133 4.7505 21.1161V14.8381H6.43823C6.61384 14.8381 7.38947 15.129 8.04538 15.4834C9.02016 16.0086 9.32114 16.2499 9.66058 16.3319C10.6683 16.6045 12.1036 16.5826 13.3818 16.774C13.5137 16.9478 13.5653 17.1352 13.5876 17.3493H10.0532C9.29243 17.339 9.29243 18.4358 10.0532 18.4255H14.2044C14.5103 18.4256 14.7602 18.1918 14.767 17.8993C14.7514 16.7957 14.4516 15.8632 13.5466 15.7111C12.1444 15.5011 10.4939 15.4609 9.96678 15.2963C9.78714 15.2402 9.10493 14.8088 8.59916 14.5466C7.90541 14.1718 7.20024 13.7618 6.43823 13.7618H4.18793C3.84403 13.7618 3.62535 14.0364 3.62535 14.3V20.578H2.12515V13.7618H2.68773C3.44851 13.7721 3.44851 12.6753 2.68773 12.6856H1.56258Z"
        fill="#2184FD"
      />
      <path
        d="M20.73 16.0341C19.4552 16.1448 17.3782 16.5912 15.8646 16.9372C15.1251 17.0981 15.3905 18.1604 16.1262 17.984C17.5789 17.6519 19.5643 17.2303 20.6919 17.1179C20.8045 17.2926 20.8311 17.3748 20.8634 17.5218C18.4299 18.4247 14.715 20.129 14.5476 20.2059L7.92486 20.5751C7.37127 20.4178 6.79979 20.1706 6.34335 19.9753C5.61078 19.7046 5.22478 20.6992 5.90677 20.9661C6.46589 21.2092 7.08724 21.4602 7.51611 21.5841C7.63727 21.6184 7.7841 21.6593 7.97028 21.6527L14.7212 21.2737C14.7941 21.2696 14.8655 21.252 14.9314 21.2218C14.9314 21.2218 19.101 19.3121 21.4677 18.4521C22.584 18.0235 21.7539 15.9161 20.73 16.0341Z"
        fill="#2184FD"
      />
    </svg>
  );
};
const ClockWhite = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.51496 1.01896C8.34401 1.00635 8.17225 1 8 1V0C8.19685 0 8.39314 0.00726199 8.58852 0.0216722L8.51496 1.01896ZM10.5193 1.46905C10.1985 1.34533 9.86912 1.2454 9.53371 1.17008L9.75282 0.194382C10.1361 0.280463 10.5126 0.394665 10.8792 0.536055L10.5193 1.46905ZM11.889 2.17971C11.7458 2.08402 11.5994 1.99388 11.4503 1.90939L11.9432 1.0393C12.1136 1.13586 12.2809 1.23888 12.4446 1.34824C12.6082 1.4576 12.7674 1.5727 12.9219 1.69322L12.3066 2.48158C12.1715 2.37612 12.0322 2.27541 11.889 2.17971ZM13.7231 3.96934C13.5252 3.68829 13.3068 3.42218 13.0697 3.17321L13.794 2.48368C14.0649 2.76821 14.3145 3.07233 14.5407 3.39353L13.7231 3.96934ZM14.4672 5.32122C14.4012 5.16208 14.3296 5.00583 14.2526 4.85271L15.1458 4.40311C15.2339 4.5781 15.3157 4.75667 15.391 4.93853C15.4664 5.12039 15.5348 5.30453 15.5962 5.49054L14.6467 5.80423C14.5929 5.64147 14.5331 5.48035 14.4672 5.32122ZM14.9979 7.82822C14.9895 7.48455 14.9557 7.14197 14.8969 6.80326L15.8822 6.63231C15.9494 7.01939 15.988 7.41092 15.9976 7.80367L14.9979 7.82822ZM14.8655 9.36563C14.8991 9.1967 14.9264 9.02699 14.9474 8.85687L15.9398 8.97929C15.9159 9.17372 15.8847 9.36766 15.8463 9.56072C15.8079 9.75378 15.7625 9.94489 15.7102 10.1337L14.7464 9.867C14.7922 9.70179 14.8319 9.53457 14.8655 9.36563ZM13.914 11.745C14.0979 11.4546 14.2602 11.151 14.3995 10.8367L15.3137 11.2419C15.1545 11.6011 14.969 11.9481 14.7588 12.28L13.914 11.745ZM12.9498 12.9497C13.0715 12.828 13.1885 12.702 13.3005 12.5722L14.0577 13.2254C13.9297 13.3737 13.796 13.5177 13.6569 13.6569L12.9498 12.9497Z"
        fill="white"
      />
      <path
        d="M8 1C6.84885 1 5.71546 1.2839 4.70023 1.82655C3.685 2.3692 2.81926 3.15386 2.17971 4.11101C1.54017 5.06816 1.14654 6.16827 1.03371 7.31388C0.920876 8.45949 1.09232 9.61525 1.53285 10.6788C1.97337 11.7423 2.66939 12.6808 3.55925 13.4111C4.44911 14.1414 5.50533 14.6409 6.63437 14.8655C7.76341 15.0901 8.93041 15.0327 10.032 14.6986C11.1336 14.3644 12.1358 13.7637 12.9498 12.9497L13.6569 13.6569C12.7266 14.5871 11.5812 15.2736 10.3223 15.6555C9.06332 16.0374 7.72961 16.1029 6.43928 15.8463C5.14895 15.5896 3.94183 15.0187 2.92486 14.1841C1.90788 13.3495 1.11243 12.2769 0.608966 11.0615C0.105504 9.846 -0.0904279 8.52514 0.0385242 7.21586C0.167476 5.90659 0.617333 4.64933 1.34825 3.55544C2.07916 2.46155 3.06857 1.5648 4.22883 0.94463C5.38909 0.324457 6.6844 0 8 0V1Z"
        fill="white"
      />
      <path
        d="M7.5 3C7.77615 3 8 3.22386 8 3.5V8.70984L11.2481 10.5659C11.4878 10.7029 11.5711 11.0083 11.4341 11.2481C11.2971 11.4878 10.9917 11.5711 10.7519 11.4341L7.25193 9.43412C7.09615 9.3451 7 9.17943 7 9V3.5C7 3.22386 7.22386 3 7.5 3Z"
        fill="white"
      />
    </svg>
  );
};
export const PauseIcon = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 27 27"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0" y="0" width="27" height="27" fill="#2FCDFF" rx="5" ry="5" />
    <rect x="7" y="7" width="4" height="12" fill="white" />
    <rect x="16" y="7" width="4" height="12" fill="white" />
  </svg>
);

function PropertyTimer(props) {
  const {
    isUnPublished,
    counterOffer,
    data,
    stage,
    propertyId,
    showSettingIcon,
    propertyData,
    publishcard,
    unpublishcard,
    upperCountDown,
    activityfun,
    inActive,
    reset,
    timerStatus,
    solidash,
    buyerFunction,
    onPropertyClickOffer,
    tradeAssistLog,
    offerStatus,
    isStickyStageTwo,
    isMakeOfferSm,
    newUI,
    setRemainingHoursTimeBlink,
    setStageTwoBlink,
    isVendorPrivateOffer,
    setStageTwoViewLog,
    isReset,
    hideHeader,
  } = props;
  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const dataType = userDetail?.userType;
  const THREE_DAYS_IN_MS = data;
  const NOW_IN_MS = new Date().getTime();
  const [dateTimeAfterThreeDays, setdateTimeAfterThreeDays] = useState(0);
  const [pause, SetPause] = useState();
  const history = useHistory();
  const [viewPrivateOffer, setViewPrivateOffer] = useState(false);

  const userData = localStorage.getItem('userDetail');
  const primaryUser = JSON.parse(userData);
  const primaryUserType = primaryUser?.primaryUserType;

  const onPropertyClick = () => {
    history.push({
      pathname: `/dashboard/property-profile/${propertyId}`,
    });
  };

  const ResetTimer = async () => {
    const data = {
      propertyId: propertyData?.property?.propertyId,
      value: 1,
      viewDetail: 'Reset',
    };
    await postApiCall(WINNER_VIEWED_BY_BUYER, data)
      .then((responses) => {
        console.log('API responses:', responses);
      })
      .catch((error) => {
        console.error('API error:', error);
      });
  };

  const determineGradient = (remainingTime, stage) => {
    if (remainingTime <= 0 || isNaN(remainingTime)) {
      return '#E2E0E0';
    }
    if (
      (stage == 'ST1' && remainingTime <= 3 * 24) ||
      (stage == 'ST2' && remainingTime <= 3)
    ) {
      return 'linear-gradient(180deg, #F93939 0%, #F8B4B4 100%)';
    }
    return 'linear-gradient(180deg, #6D3BD6 0%, #6F5BDF 25.21%, #74A8F3 85.1%, #74B2F6 92.92%, #75BBF8 100%)';
  };
  const BorderLinearProgress = styled(LinearProgress)(
    ({ theme, gradientColor }) => ({
      height: 10,
      borderRadius: 5,
      marginTop: '8px',
      [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: '#E2E0E0',
      },
      [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        background: gradientColor,
        transform: 'rotate(-90deg)',
      },
    })
  );
  useEffect(() => {
    if (propertyData?.stage !== 0 && propertyData?.timerStatus === 'Start') {
      const currentTime = moment().valueOf();
      const dateWithStartAtCal = moment(propertyData?.startedAt).format();
      const duration = moment.duration(
        propertyData?.timerDuration,
        'milliseconds'
      );

      const runningDate = moment(dateWithStartAtCal).add(duration).toDate();
      setdateTimeAfterThreeDays(runningDate);
    } else if (
      propertyData?.stage !== 0 &&
      propertyData?.timerStatus === 'Pause'
    ) {
      SetPause(propertyData?.pausedTimerDuration);
      const currentTime = moment().valueOf();
      const dateWithStartAtCal = moment(propertyData?.startedAt).format();
      const duration = moment.duration(
        propertyData?.timerDuration,
        'milliseconds'
      );
      const runningDate = moment(dateWithStartAtCal).add(duration).toDate();
      setdateTimeAfterThreeDays(runningDate);
    } else {
      const dateWithStartAtCal = moment(propertyData?.startedAt).format();
      const runningDate = moment(dateWithStartAtCal).toDate();
      setdateTimeAfterThreeDays(runningDate);
    }
  }, [propertyData]);

  const [isRunning, setIsRunning] = React.useState(true);
  const [openBox, setOpenBox] = useState(false);

  const [progress, setProgress] = useState({
    time: 0,
    unpubtime: 0,
    remainingHoursTime: 0,
    remainingHoursUnpub: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      var totalTimeMillis = moment(
        dateTimeAfterThreeDays,
        'YYYY-MM-DD HH:mm:ss:SSS'
      ).diff(moment(propertyData?.startedAt, 'YYYY-MM-DD HH:mm:ss:SSS'));
      var remainingMillis = moment(
        new Date(
          new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
        ).getTime()
      ).diff(moment(propertyData?.startedAt, 'YYYY-MM-DD HH:mm:ss:SSS'));
      var time = Math.floor(
        isNaN(remainingMillis)
          ? 100
          : (1 - remainingMillis / totalTimeMillis) * 100
      );

      let end = new Date(propertyData?.startedAt).valueOf();
      let start = new Date(propertyData?.property?.propertyCreated).valueOf();
      const now = new Date(
        new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
      ).getTime();
      var unpubtime = Math.floor((1 - (now - start) / (end - start)) * 100);

      const remainingHoursTime = totalTimeMillis
        ? (totalTimeMillis - remainingMillis) / (60 * 60 * 1000)
        : 0;

      const remainingHoursUnpub =
        end - now > 0 ? (end - now) / (60 * 60 * 1000) : 0;
      setProgress({ time, unpubtime, remainingHoursTime, remainingHoursUnpub });
    }, 1000);

    return () => clearInterval(interval);
  }, [propertyData, dateTimeAfterThreeDays]);

  useEffect(() => {
    if (setRemainingHoursTimeBlink && setStageTwoBlink) {
      setRemainingHoursTimeBlink(progress?.remainingHoursTime);
      setStageTwoBlink(propertyData?.stage);
    }
  }, [
    progress?.remainingHoursTime,
    setRemainingHoursTimeBlink,
    setStageTwoBlink,
    propertyData?.stage,
  ]);

  const [viewLoader, setViewLoader] = useState(false);
  const handleBuyerPrivateOfferViewApiCall = async () => {
    let input = {
      propertyId: propertyId,
      agentId: propertyData?.agentDetails?.agentId,
    };

    try {
      setViewLoader(true);

      const response = await postApiCall(POST_BUYER_PRIVATEOFFER_VIEW, input);

      if (response?.data?.status == 1) {
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setViewLoader(false);
    }
  };

  const [closeLoader, setCloseLoader] = useState(false);
  const handleBuyerPrivateOfferCloseApiCall = async () => {
    let input = {
      propertyId: propertyId,
      bannerCode: 'BUYER001',
      bannerHeading: 'Buyer Private Offer trigger from property card',
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_BUYER_BANNER_CLOSE, input);

      if (response?.data?.status == 1) {
        buyerFunction();
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  const onPrivateOfferClick = (propertyId) => {
    history.push({
      pathname: `market/${propertyId}`,
      state: {
        propertyIds: true,
        dashboardPrivateOfferView: true,
      },
    });
  };

  const onPropertyClick1 = (propertyId) => {
    history.push({
      pathname: `market/${propertyId}`,
      state: {
        propertyIds: true,
        openBuyerManageOffer: true,
      },
    });
  };

  const handlePrivateOfferCloseApiCall = async () => {
    let input = {
      propertyId: propertyId,
      bannerCode: 'BAN001',
      bannerHeading: 'Private Offer trigger',
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_VENDOR_BANNER_CLOSE, input);

      if (response?.data?.status == 1) {
        publishcard();
        unpublishcard();
        activityfun();
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  const handlePrivateOfferView = async () => {
    let input = {
      propertyId: propertyId,
      agentId: propertyData?.agentDetails?.agentId,
    };

    try {
      setViewLoader(true);
      const response = await postApiCall(
        POST_VENDOR_BANNER_PRIVATE_OFFER,
        input
      );
      if (response?.data?.status == 1) {
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setViewLoader(false);
    }
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matchesB = useMediaQuery(theme.breakpoints.between(1536, 1636));
  const currentPage = window.location.pathname;
  const sxStyle =
    currentPage.includes('/market') && primaryUserType == 'Buyer'
      ? upperCountDown
        ? counterContMarketUpper
        : counterContMarket
      : counterCont;

  const counterContAgent = {
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    padding: '5px',
    backgroundColor: 'none',
  };
  const savedsearch = {
    height: '100px',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '20px',
  };

  const handleReviewClick = () => {
    sessionStorage.setItem('triggerViewPrivateOffer', 'true');
    history.push({
      pathname: `/dashboard/viewactive-dashboard/${propertyId}`,
      state: { triggerViewPrivateOffer: true },
    });
  };

  const isSmallScreen = useMediaQuery('(max-width:390px)');

  const ST2Counter = (status) => {
    const input = {
      propertyId: propertyId,
      status: status,
      isAccept: 0,
    };
    stageTwoCounter(input).then((res) => {
      if (res?.status == 1) {
        buyerFunction();
      } else {
      }
      if (status == 'viewed') {
        if (tradeAssistLog != 0) {
          onPropertyClick1(propertyId);
        } else {
          onPropertyClick1(propertyId);
        }
      }
    });
  };

  return (
    <Grid
      sx={
        currentPage.includes('/Savedsearch')
          ? savedsearch
          : (currentPage.includes('/dashboard') &&
              primaryUserType == 'Agent') ||
            (currentPage.includes('/dashboard') && primaryUserType == 'Vendor')
          ? sxStyle
          : counterContAgent
      }
      style={{ borderRadius: '5px' }}
    >
      <Grid
        sx={
          (currentPage.includes('/market') && primaryUserType == 'Buyer') ||
          currentPage.includes('/Savedsearch') ||
          currentPage.includes('/share')
            ? counterSubPropMarket
            : counterSubProp(stage, reset)
        }
        style={{ display: newUI && 'none', flexDirection: 'row' }}
      >
        {!hideHeader &&
          (currentPage.includes('/People') ||
            currentPage.includes('/dashboard') ||
            currentPage.includes('/BuyerDashboard') ||
            currentPage.includes('/landingpage') ||
            currentPage.includes('/VendorDashboard') ||
            currentPage.includes('/VendorIndividualDashboard') ||
            currentPage.includes('/VendorInactiveIndividual') ||
            currentPage.includes('/insights') ||
            currentPage.includes('/message') ||
            currentPage.includes('/tasks') ||
            currentPage.includes('/notification')) && (
            <Grid
              sx={{
                ...poppins400,
                display: 'flex',
                alignItems: 'center',
                fontSize: matches450
                  ? '14px'
                  : matchessm
                  ? '16px'
                  : matchesB
                  ? '18px'
                  : '20px',
                color:
                  counterOffer === null &&
                  (offerStatus == 'Counter Received' ||
                    offerStatus == 'Private Offer') &&
                  stage == 'ST1'
                    ? 'white'
                    : '#222222',
                whiteSpace: 'nowrap',
              }}
            >
              {counterOffer === null &&
              (offerStatus == 'Counter Received' ||
                offerStatus == 'Private Offer') &&
              stage == 'ST1' ? (
                <ClockWhite width={20} height={20} />
              ) : (
                <Clock width={20} height={20} />
              )}{' '}
              &nbsp;{' '}
              {isVendorPrivateOffer
                ? 'Campaign Timer'
                : counterOffer === null &&
                  (offerStatus == 'Counter Received' ||
                    offerStatus == 'Private Offer') &&
                  stage == 'ST1'
                ? 'This offer expires in :'
                : dataType?.length === 1
                ? isUnPublished
                  ? 'Countdown Timer'
                  : 'Campaign Timer'
                : 'CountDownTimer'}
            </Grid>
          )}

        {!hideHeader &&
          (currentPage.includes('/People') ||
            currentPage.includes('/landingpage') ||
            currentPage.includes('/dashboard') ||
            currentPage.includes('/BuyerDashboard') ||
            currentPage.includes('/VendorDashboard') ||
            currentPage.includes('/VendorIndividualDashboard') ||
            currentPage.includes('/VendorInactiveIndividual') ||
            currentPage.includes('/insights') ||
            currentPage.includes('/message') ||
            currentPage.includes('/tasks') ||
            currentPage.includes('/notification')) && (
            <Grid
              container
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                visibility:
                  counterOffer === null &&
                  offerStatus == 'Counter Received' &&
                  stage == 'ST1' &&
                  'hidden',
              }}
            >
              {((publishcard &&
                !isUnPublished &&
                primaryUserType == 'Agent' &&
                timerStatus == 'Pause') ||
                (timerStatus == 'Pause' && primaryUserType == 'Buyer') ||
                (timerStatus == 'Pause' &&
                  primaryUserType == 'Vendor' &&
                  !inActive)) && (
                <Grid item sx={stagePause(stage, reset)}>
                  {' '}
                  <Button
                    sx={{
                      mt: -1,
                      mr: matchessm ? -8 : -2,
                      '&:hover': {
                        backgroundColor: 'inherit',
                        cursor:
                          primaryUserType === 'Buyer' ||
                          primaryUserType === 'Vendor'
                            ? 'default'
                            : 'pointer',
                      },
                    }}
                    onClick={() => {
                      primaryUserType == 'Agent' && setOpenBox(true);
                    }}
                    disableRipple={true}
                  >
                    <PauseIcon width={27} height={27} />
                  </Button>
                  <Timerstatus
                    openBox={openBox}
                    setOpenBox={setOpenBox}
                    profileDetails={propertyData}
                    actionValue={
                      propertyData?.timerStatus == 'Start' ? 'Pause' : 'Start'
                    }
                    publishcard={publishcard}
                    unpublishcard={unpublishcard}
                    activityfun={activityfun}
                    dashboard={true}
                  />
                </Grid>
              )}
              {/* {!isUnPublished && (
                <StageTagSelector
                  timerStatus={timerStatus}
                  stage={stage}
                  reset={reset}
                  isUnPublished={isUnPublished}
                  matches450={matches450}
                  matchesB={matchesB}
                />
              )} */}

               {!isUnPublished && (
                <>
                  {timerStatus === 'End' && (
                    <Ended
                      matches450={matches450}
                      matchesB={matchesB}
                      customStyles={{ position: 'absolute', right: 0, padding: '3px 6px' }}
                    />
                  )}

                  {timerStatus !== 'End' && stage === 'ST1' && (
                    <Stage1
                      matches450={matches450}
                      matchesB={matchesB}
                      customStyles={{ position: 'absolute', right: 0, padding: '3px 6px' }}
                    />
                  )}

                  {timerStatus !== 'End' &&
                    stage === 'ST2' &&
                    reset == '1' && (
                      <Stage2Final
                        matches450={matches450}
                        matchesB={matchesB}
                        customStyles={{ position: 'absolute', right: 0, padding: '3px 6px' }}
                      />
                    )}

                  {timerStatus !== 'End' &&
                    stage === 'ST2' &&
                    reset != '1' && (
                      <Stage2
                        matches450={matches450}
                        matchesB={matchesB}
                        customStyles={{ position: 'absolute', right: 0, padding: '3px 6px' }}
                      />
                    )}
                </>
              )}
              {/* {!isUnPublished && (
  <>
    {timerStatus === 'End' && <Ended matches450={matches450} matchesB={matchesB} />}
    {stage === 'ST1' && <Stage1 matches450={matches450} matchesB={matchesB} />}
    {stage === 'ST2' && reset === '1' && <Stage2Final matches450={matches450} matchesB={matchesB} />}
    {stage === 'ST2' && reset !== '1' && <Stage2 matches450={matches450} matchesB={matchesB} />}
  </>
)} */}
            </Grid>
          )}
        {currentPage.includes('/share') ||
          (currentPage.includes('/market') &&
            primaryUserType == 'Buyer' &&
            !upperCountDown &&
            timerStatus != 'End' && (
              <>
                <Typography
                  style={{
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    animation:
                      propertyData?.stage == 'ST2' &&
                      progress?.remainingHoursTime > 0 &&
                      progress?.remainingHoursTime <= 3
                        ? 'blink 1s infinite'
                        : propertyData?.stage == 'ST2' &&
                          propertyData?.stageTwoViewLog != null &&
                          propertyData?.stageTwoViewLog?.isAccept == '0' &&
                          propertyData?.stageTwoViewLog?.status == 'viewed'
                        ? 'blink 1s 10'
                        : 'none',
                  }}
                  sx={{
                    ...(propertyData?.stage == 'ST1' &&
                      stageContMarket('rgba(16, 211, 94, 1)', '12px')),
                    ...(propertyData?.stage == 'ST2' &&
                      propertyData?.isReset == '0' &&
                      stageContMarketSt2('rgba(249, 57, 57, 1)', '12px')),
                    ...(propertyData?.stage == 'ST2' &&
                      propertyData?.isReset == '1' &&
                      stageContMarketStage('rgba(249, 57, 57, 1)', '12px')),
                    ...(timerStatus == 'End' &&
                      stageContMarket('#585858', '12px')),
                  }}
                >
                  {timerStatus == 'End'
                    ? 'ENDED'
                    : propertyData?.stage == 'ST1'
                    ? 'STAGE 1'
                    : propertyData?.stage == 'ST2' &&
                      propertyData?.isReset == '1'
                    ? 'STAGE 2 - FINAL OFFERS'
                    : 'STAGE 2'}
                </Typography>
                {timerStatus == 'Pause' && (
                  <Box
                    sx={{
                      position: 'absolute',
                      right: propertyData?.isReset == '1' ? '27px' : '80px',
                      paddingTop: '5px',
                    }}
                  >
                    <PauseIcon width={20} height={18} />
                  </Box>
                )}
              </>
            ))}
      </Grid>
      <Typography sx={{ textAlign: 'center', display: newUI && 'none' }}>
        {(currentPage.includes('/People') ||
          currentPage.includes('/solicitor') ||
          currentPage.includes('/landingpage') ||
          currentPage.includes('/dashboard') ||
          (currentPage.includes('/dashboard') && primaryUserType == 'Buyer') ||
          currentPage.includes('/VendorDashboard') ||
          currentPage.includes('/VendorIndividualDashboard') ||
          currentPage.includes('/VendorInactiveIndividual') ||
          currentPage.includes('/insights') ||
          (currentPage.includes('/share') && !upperCountDown) ||
          (currentPage.includes('/market') &&
            (primaryUserType == 'Buyer' || primaryUserType == 'Vendor') &&
            !upperCountDown) ||
          currentPage.includes('/tasks') ||
          currentPage.includes('/notification')) && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0,
            }}
          >
            <CountdownTimer
              counterOffer={counterOffer}
              offerStatus={offerStatus}
              isRunning={isRunning}
              targetDate={dateTimeAfterThreeDays}
              propertyId={propertyId}
              isUnPublished={isUnPublished}
              publishcard={publishcard}
              unpublishcard={unpublishcard}
              paused={pause}
              pausestatus={propertyData?.timerStatus === 'Pause' ? true : false}
              stage={propertyData?.stage}
              highestOfferId={propertyData?.highestOfferId}
              isWinner={propertyData?.isWinner}
              activityfun={activityfun}
              startedAt={propertyData?.startedAt}
              propertydata={propertyData}
              solidash={solidash}
              isReset={isReset}
              ResetTimer={ResetTimer}
              hideHeader={hideHeader}
            />

            {hideHeader && timerStatus === 'Pause' && (
              <Button
                sx={{
                  minWidth: 'auto',
                  padding: 0,
                  ml: '-10px',
                  '&:hover': {
                    backgroundColor: 'inherit',
                    cursor:
                      primaryUserType === 'Buyer' ||
                      primaryUserType === 'Vendor'
                        ? 'default'
                        : 'pointer',
                  },
                }}
                onClick={() => {
                  if (primaryUserType === 'Agent') {
                    setOpenBox(true);
                  }
                }}
                disableRipple={true}
              >
                <PauseIcon width={20} height={18} />
              </Button>
            )}
          </Box>
        )}
        <Timerstatus
          openBox={openBox}
          setOpenBox={setOpenBox}
          profileDetails={propertyData}
          actionValue={propertyData?.timerStatus == 'Start' ? 'Pause' : 'Start'}
          publishcard={publishcard}
          unpublishcard={unpublishcard}
          activityfun={activityfun}
          dashboard={true}
        />

        {(currentPage.includes('/share') ||
          (currentPage.includes('/market') &&
            (primaryUserType == 'Buyer' || primaryUserType == 'Vendor'))) &&
          upperCountDown && (
            <CountdownTimer
              isRunning={isRunning}
              targetDate={dateTimeAfterThreeDays}
              propertyId={propertyId}
              isUnPublished={isUnPublished}
              publishcard={publishcard}
              unpublishcard={unpublishcard}
              paused={pause}
              upperCountDown={upperCountDown}
              pausestatus={propertyData?.timerStatus === 'Pause' ? true : false}
              stage={propertyData?.stage}
              highestOfferId={propertyData?.highestOfferId}
              isWinner={propertyData?.isWinner}
              startedAt={propertyData?.startedAt}
              isStickyStageTwo={isStickyStageTwo}
              isMakeOfferSm={isMakeOfferSm}
              isReset={isReset}
              ResetTimer={ResetTimer}
            />
          )}

        {currentPage.includes('/Savedsearch') && (
          <CountdownTimer
            isRunning={isRunning}
            targetDate={dateTimeAfterThreeDays}
            propertyId={propertyId}
            isUnPublished={isUnPublished}
            publishcard={publishcard}
            unpublishcard={unpublishcard}
            paused={pause}
            upperCountDown={upperCountDown}
            pausestatus={propertyData?.timerStatus === 'Pause' ? true : false}
            stage={propertyData?.stage}
            highestOfferId={propertyData?.highestOfferId}
            isWinner={propertyData?.isWinner}
            startedAt={propertyData?.startedAt}
            isReset={isReset}
            ResetTimer={ResetTimer}
          />
        )}
      </Typography>
      {showSettingIcon && !upperCountDown ? (
        <Typography
          sx={{ minWidth: newUI && '100%' }}
          style={{
            textAlign: 'right',
            position: 'relative',
            top: '-4px',
            padding: '0px 30px',
            margin: matchessm ? '1px' : '10px 0px',
          }}
        >
          <Grid
            container
            sx={{
              display:
                counterOffer === null &&
                (offerStatus == 'Counter Received' ||
                  offerStatus == 'Private Offer') &&
                stage == 'ST1'
                  ? 'none'
                  : 'auto',
              width: newUI
                ? '100%'
                : currentPage.includes('/share') ||
                  (currentPage.includes('/market') &&
                    primaryUserType == 'Buyer')
                ? '279px'
                : '100%',
              alignItems: 'center',
            }}
            gap={2}
          >
            {(currentPage.includes('/People') ||
              currentPage.includes('/landingpage') ||
              currentPage.includes('/dashboard') ||
              currentPage.includes('/BuyerDashboard') ||
              currentPage.includes('/VendorDashboard') ||
              currentPage.includes('/VendorIndividualDashboard') ||
              currentPage.includes('/VendorInactiveIndividual') ||
              currentPage.includes('/insights') ||
              currentPage.includes('/message') ||
              currentPage.includes('/tasks') ||
              currentPage.includes('/notification')) && (
              <Grid item width={newUI ? '100%' : isSmallScreen ? '65%' : '75%'}>
                {isUnPublished ? (
                  <>
                    <BorderLinearProgress
                      variant="determinate"
                      value={progress.unpubtime}
                      gradientColor={determineGradient(
                        progress.remainingHoursUnpub,
                        stage
                      )}
                      sx={{ height: '13px' }}
                    />
                  </>
                ) : (
                  <BorderLinearProgress
                    variant="determinate"
                    value={progress.time}
                    gradientColor={determineGradient(
                      progress.remainingHoursTime,
                      stage
                    )}
                    sx={{ height: '13px' }}
                  />
                )}
              </Grid>
            )}

            {(currentPage.includes('/share') ||
              (currentPage.includes('/market') &&
                primaryUserType == 'Buyer')) &&
              !upperCountDown && (
                <Grid item width={newUI ? '100%' : '80%'} paddingTop={'10px'}>
                  {isUnPublished ? (
                    <>
                      <BorderLinearProgress
                        variant="determinate"
                        value={progress.unpubtime}
                        gradientColor={determineGradient(
                          progress.remainingHoursUnpub,
                          stage
                        )}
                        sx={{ height: '13px' }}
                      />
                    </>
                  ) : (
                    <BorderLinearProgress
                      variant="determinate"
                      value={progress.time}
                      gradientColor={determineGradient(
                        progress.remainingHoursTime,
                        stage
                      )}
                      sx={{ height: '13px' }}
                    />
                  )}
                </Grid>
              )}
            {((currentPage.includes('/dashboard') &&
              primaryUserType == 'Agent') ||
              (currentPage.includes('/dashboard') &&
                primaryUserType == 'Vendor') ||
              (currentPage.includes('/dashboard') &&
                primaryUserType == 'Vendor') ||
              (currentPage.includes('/dashboard') &&
                primaryUserType !== 'Buyer') ||
              currentPage.includes('/People') ||
              currentPage.includes('/BuyerDashboard') ||
              currentPage.includes('/VendorDashboard') ||
              currentPage.includes('/VendorIndividualDashboard') ||
              currentPage.includes('/VendorInactiveIndividual') ||
              currentPage.includes('/insights') ||
              currentPage.includes('/message') ||
              currentPage.includes('/tasks') ||
              currentPage.includes('/notification')) && (
              <Grid item>
                {primaryUserType !== 'Vendor' && (
                  <Typography>
                    <PropertySettingAction
                      isUnPublished={isUnPublished}
                      propertyData={propertyData}
                      inActive={inActive}
                      publishcard={publishcard}
                      unpublishcard={unpublishcard}
                      activityfun={activityfun}
                    />
                  </Typography>
                )}
              </Grid>
            )}
          </Grid>
          {isVendorPrivateOffer ? (
            <Grid
              sx={{
                display:
                  offerStatus == 'Private Offer' && stage == 'ST1'
                    ? 'flex'
                    : 'none',
                justifyContent: 'center',
                gap: '20px',
                marginTop: '20px',
              }}
            >
              <Button
                onClick={handlePrivateOfferCloseApiCall}
                sx={{
                  fontFamily: 'poppins',
                  fontSize: '14px',
                  color: 'white',
                  fontWeight: 400,
                  padding: '5px 30px',
                  border: '1px solid #E6F2FF',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                  width: '105px',
                }}
              >
                Defer
              </Button>
              <Button
                onClick={() => {
                  handleReviewClick();
                }}
                startIcon={<ViewIcon />}
                style={{
                  fontFamily: 'poppins',
                  fontSize: '14px',
                  color: '#2184FD',
                  background: 'white',
                  fontWeight: 400,
                  padding: '5px 30px',
                  border: '1px solid white',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                  width: '115px',
                }}
              >
                Review
              </Button>
            </Grid>
          ) : (
            <Grid
              sx={{
                display:
                  counterOffer === null &&
                  (offerStatus == 'Counter Received' ||
                    offerStatus == 'Private Offer') &&
                  stage == 'ST1'
                    ? 'flex'
                    : 'none',
                justifyContent: 'center',
                gap: '20px',
                marginTop: '5px',
              }}
            >
              <Button
                onClick={() => {
                  if (offerStatus == 'Counter Received') {
                    ST2Counter('ignored');
                  } else if (offerStatus == 'Private Offer') {
                    handleBuyerPrivateOfferCloseApiCall();
                  }
                }}
                sx={{
                  fontFamily: 'poppins',
                  fontSize: '14px',
                  color: 'white',
                  fontWeight: 400,
                  padding: '5px 30px',
                  border: '1px solid white',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                {offerStatus == 'Counter Received' ? 'Ignore' : 'Defer'}
              </Button>
              <Button
                onClick={() => {
                  localStorage.setItem('issurveyskipped', true);
                  if (offerStatus == 'Counter Received') {
                    ST2Counter('viewed');
                  } else if (offerStatus == 'Private Offer') {
                    onPrivateOfferClick(propertyId);
                  }
                }}
                startIcon={<ViewIcon />}
                style={{
                  fontFamily: 'poppins',
                  fontSize: '14px',
                  color: '#2184FD',
                  background: 'white',
                  fontWeight: 400,
                  padding: '5px 30px',
                  border: '1px solid white',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                {offerStatus == 'Counter Received' ? 'View' : 'Review'}
              </Button>
            </Grid>
          )}
        </Typography>
      ) : null}
    </Grid>
  );
}

PropertyTimer.defaultProps = {
  isUnPublished: false,
  showSettingIcon: true,
};

PropertyTimer.propTypes = {
  isUnPublished: PropTypes.bool,
  showSettingIcon: PropTypes.bool,
};

export default PropertyTimer;
